import React, { useState } from 'react';

import { Tag, Modal, Form, Input } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';

import { HttpClient } from '../../utils/HttpClient';

const { Item }: any = Form;
const { TextArea } = Input;

const layout = {
    labelCol: {
        span: 6,
    },
    wrapperCol: {
        span: 20,
    },
};

const FeedbackModal: React.FunctionComponent = () => {
    const [modalVisibility, setModalVisibility] = useState(false);
    const [formError, setFormError] = useState('');
    const [feedBackForm] = Form.useForm();
    return (
        <>
            <div className="contact">
                <Tag onClick={(): void => setModalVisibility(true)} icon={<QuestionCircleOutlined />}>
                    Send feedback
                </Tag>
            </div>
            <Modal
                title="Report incidents or send feedback"
                visible={modalVisibility}
                onCancel={(): any => {
                    setModalVisibility(false);
                    setFormError('');
                }}
                okText="Submit feedback"
                onOk={async (): Promise<void> => {
                    if (feedBackForm.getFieldValue('message')) {
                        const payload = feedBackForm.getFieldsValue();
                        try {
                            await HttpClient.post(`/feedback/slack`, payload);
                            setModalVisibility(false);
                            feedBackForm.resetFields();
                        } catch (err) {
                            setFormError('Error contacting the server, try again later');
                        }
                    } else {
                        setFormError('Please submit a message');
                    }
                }}
            >
                <Form
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...layout}
                    name="feedback"
                    form={feedBackForm}
                >
                    <Item name="message" type="textarea" required label="Your feedback">
                        <TextArea autoSize={{ minRows: 3, maxRows: 10 }} />
                    </Item>
                    {formError.length ? (
                        <div className="alert alert-warning">
                            <strong>{formError}</strong>
                        </div>
                    ) : (
                        ''
                    )}
                </Form>
            </Modal>
        </>
    );
};

export default FeedbackModal;
